__turbopack_context__.v({
  "protection": "styles-module__AP1IWq__protection",
  "protectionLink": "styles-module__AP1IWq__protectionLink",
});
